export type ReportConfig = {
  id: string;
  title: string;
  type: 'native' | 'powerbi';
  url?: string;
  embedUrl?: string;
};

function toEmbedUrl(url: string): string {
  const match = url.match(/\/groups\/([^/]+)\/reports\/([^/?]+)/i);
  if (!match) {
    return url;
  }

  const groupId = match[1];
  const reportId = match[2];
  return `https://app.powerbi.com/reportEmbed?groupId=${groupId}&reportId=${reportId}&autoAuth=true&filterPaneEnabled=false&navContentPaneEnabled=false`;
}

export const REPORTS: ReportConfig[] = [
  {
    id: 'month-end-report',
    title: 'Month End Report',
    type: 'native',
  },
  {
    id: 'top-down-performance',
    title: 'Top Down Performance',
    type: 'native',
  },
  {
    id: 'associate-report',
    title: 'Associate Report',
    type: 'native',
  },
  {
    id: 'cappers-report',
    title: 'Cappers Report',
    type: 'native',
  },
  {
    id: 'listings-location-report',
    title: 'Listings Location Report',
    type: 'native',
  },
  {
    id: 'trend-report',
    title: 'Trend Report',
    type: 'powerbi',
    url: 'https://app.powerbi.com/groups/3c83a25b-cb0a-4ec6-bda2-d697e878c99e/reports/ab0bab62-24db-49ae-991b-651da20a4b59?experience=power-bi',
    embedUrl: toEmbedUrl('https://app.powerbi.com/groups/3c83a25b-cb0a-4ec6-bda2-d697e878c99e/reports/ab0bab62-24db-49ae-991b-651da20a4b59?experience=power-bi'),
  },
];

export function findReportById(reportId: string | undefined): ReportConfig {
  if (reportId === 'top-down-agent' || reportId === 'top-down-team' || reportId === 'top-down-agent-native') {
    return REPORTS.find((report) => report.id === 'top-down-performance') ?? REPORTS[0];
  }
  return REPORTS.find((report) => report.id === reportId) ?? REPORTS[0];
}
